import { render, staticRenderFns } from "./TeamWs.vue?vue&type=template&id=fafe6f28"
import script from "./TeamWs.vue?vue&type=script&lang=js"
export * from "./TeamWs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports